import Button from "Components/shared/button";
import Modal from "Components/shared/modal";
import Text from "Components/shared/text";
import React from "react";
import styles from "./account.module.css";

export const DeleteCardModal = ({
  openModal,
  setOpenModal,
  buttonText,
  deleteMessage,
  deleteHeader,
  blockCard,
  // handleDeleteCard,
  loading
}) => {
  return (
    <Modal
      open={openModal}
      onClose={() => setOpenModal(false)}
      disableBackdropClick
      heading={deleteHeader}
    >
      <Text variant="xs" color="secondary">
        {deleteMessage}
      </Text>

      <div
        className="row-start"
        style={{
          gap: "1rem",
          marginTop: "2rem",
        }}
      >
        <div className={styles.flexButton}>
          <Button
            label={buttonText}
            className={(styles.button, styles.cancel)}
            variant="outlined"
            color="danger"
            onClick={blockCard}
            loading={loading}
          />
        </div>
        <div className={styles.flexButton}>
          <Button
            label="Cancel"
            className={(styles.button, styles.cancle)}
            onClick={() => setOpenModal(false)}
          />
        </div>
      </div>
    </Modal>
  );
};
